var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXls = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2DCB6F",
  fillRule: "evenodd",
  d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 0v4a2 2 0 0 0 2 2h4z",
  opacity: 0.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 8,
  x: 2,
  y: 13,
  fill: "#F7F8FA",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2DCB6F",
  d: "m5.162 15.053.757 1.232h.033l.765-1.232h1.121l-1.25 1.949 1.29 1.949H6.73l-.777-1.245h-.033l-.777 1.245H4L5.286 17l-1.254-1.948zM8.927 18.95v-3.897h1.002v3.133h1.725v.765zM14.984 16.222a.43.43 0 0 0-.18-.326q-.159-.117-.452-.118a1 1 0 0 0-.324.048.4.4 0 0 0-.194.131.3.3 0 0 0-.067.189q-.004.087.036.154a.4.4 0 0 0 .122.118 1 1 0 0 0 .194.087q.113.039.255.067l.357.076q.308.063.542.167.237.105.397.25a.97.97 0 0 1 .33.755 1.04 1.04 0 0 1-.198.634q-.197.264-.565.405a2.5 2.5 0 0 1-.885.141q-.521 0-.907-.146a1.27 1.27 0 0 1-.601-.446q-.215-.298-.22-.755h.959q.012.188.107.314.095.125.261.19.168.065.389.065.203 0 .344-.052a.5.5 0 0 0 .22-.142.33.33 0 0 0 .08-.21.28.28 0 0 0-.073-.188.55.55 0 0 0-.219-.137 2.4 2.4 0 0 0-.372-.109l-.434-.095q-.538-.116-.848-.375-.31-.26-.308-.704a1 1 0 0 1 .207-.633q.208-.273.577-.425t.84-.152q.482 0 .836.154.357.152.553.428t.2.64z"
})));
export default SvgXls;